"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StatusBar = _interopRequireDefault(require("./StatusBar"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../../components");
var _lib = require("../../../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TopPanel = function TopPanel(_ref) {
  var connectionStatus = _ref.connectionStatus,
    allowFullScreen = _ref.allowFullScreen,
    screenSharingInProgress = _ref.screenSharingInProgress;
  var _useVideoChat = (0, _lib.useVideoChat)(),
    isMaximized = _useVideoChat.isMaximized,
    isFullScreen = _useVideoChat.isFullScreen,
    isSubscribed = _useVideoChat.isSubscribed,
    maximize = _useVideoChat.maximize,
    target = _useVideoChat.target,
    toggleFullScreen = _useVideoChat.toggleFullScreen,
    eventHandler = _useVideoChat.videoControlEventHandler;
  var isMinimized = !isMaximized && !isFullScreen;
  var isFullScreenChangeAvailable = !isMinimized && allowFullScreen;
  var buttonColor = screenSharingInProgress ? 'black' : 'white';
  var buttonColorStyles = "text-".concat(buttonColor, " active:text-").concat(buttonColor, " focus:text-").concat(buttonColor, " hover:text-").concat(buttonColor);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('top-panel', 'absolute top-0 w-full', 'border-0 border-b-[1px] border-grey-55 border-solid', 'tw-body-sm-medium bg-black', {
      '!bg-alertred-10': screenSharingInProgress
    })
  }, screenSharingInProgress && /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full text-center text-alertred-60 h-[44px] py-[12px] px-[23px]"
  }, "You are sharing your screen"), /*#__PURE__*/_react.default.createElement(_StatusBar.default, {
    companion: target,
    connectionStatus: connectionStatus,
    isConnected: isSubscribed
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute right-[38px] top-[10px]"
  }, isMinimized && /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: "arrow-long-left",
    onClick: eventHandler(maximize),
    onTouchStart: eventHandler(maximize),
    className: buttonColorStyles
  }), isFullScreenChangeAvailable && /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: isFullScreen ? 'fullscreen-exit' : 'fullscreen',
    onClick: eventHandler(toggleFullScreen),
    onTouchStart: eventHandler(toggleFullScreen),
    className: buttonColorStyles
  })));
};
TopPanel.propTypes = {
  allowFullScreen: _propTypes.default.bool,
  screenSharingInProgress: _propTypes.default.bool,
  connectionStatus: _propTypes.default.string
};
var _default = TopPanel;
exports.default = _default;